import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

Vue.use(Router);

export const privateRoutes = [
  {
    name: "Types",
    path: "categories",
    meta: {
      permissions: []
    },
    component: () =>
      import(/* webpackChunkName: "Types" */ "@/pages/Types/List.vue")
  },
  {
    name: "Type",
    path: "categories/:typeId",
    meta: {
      permissions: []
    },
    component: () =>
      import(/* webpackChunkName: "TypeUpsert" */ "@/pages/Types/Upsert.vue")
  },
  {
    name: "FAQs",
    path: "categories/:typeId/faqs",
    meta: {
      permissions: []
    },
    component: () =>
      import(/* webpackChunkName: "FAQs" */ "@/pages/Types/FAQs/List.vue")
  },
  {
    name: "FAQ",
    path: "categories/:typeId/faqs/:faqId",
    meta: {
      permissions: []
    },
    component: () =>
      import(/* webpackChunkName: "FAQUpsert" */ "@/pages/Types/FAQs/Upsert.vue")
  }
];

export const routes = [
  {
    path: "/",
    id: "Navshell",
    component: () =>
      import(/* webpackChunkName: "Navshell" */ "@/pages/Navshell.vue"),
    children: privateRoutes,
    redirect: { name: "Types" }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "@/pages/Login.vue")
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && !store.state.auth.token) {
    store.dispatch("auth/goToLoginUrl", null, { root: true });
  } else next();
});

export default router;
